<template>
  <AppPanel :show="show" label-id="customers-title" :title="title" :subtitle="subtitle"
    @close="$emit('close')">
    <template v-if="editing" #start>
      <CButton color="light" class="flex-shrink-0" aria-label="Back to the list" @click="list">
        <CIcon icon="cil-arrow-left" />
      </CButton>
    </template>

    <Upsert v-if="editing" ref="form" :key="key ?? 'new'" :tenant="key ?? ''" @saved="saved" />
    <List v-else :key="reload" @edit="edit" @select="$emit('close')" @changed="$emit('changed')" />

    <template #actions>
      <template v-if="editing">
        <CButton color="secondary" variant="ghost" class="ms-auto" @click="list">Cancel</CButton>
        <CButton color="success" @click="save">
          {{ key ? 'Save customer' : 'Create customer' }}
        </CButton>
      </template>
      <CButton v-else color="success" class="ms-auto" @click="edit(undefined)">
        <CIcon icon="cil-plus" />
        <span class="ms-2">New customer</span>
      </CButton>
    </template>
  </AppPanel>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AppPanel from '@/components/AppPanel.vue'
import List from '@/components/tenant/actions/list.vue'
import Upsert from '@/components/tenant/actions/upsert.vue'
import type { FormHandle } from '@/types/api'

export default defineComponent({
  name: 'TenantPanel',
  components: { AppPanel, List, Upsert },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'changed'],
  data() {
    return {
      editing: false,
      key: undefined as string | undefined,
      reload: 0,
    }
  },
  computed: {
    title(): string {
      if (!this.editing) return 'Customers'
      return this.key ? 'Edit customer' : 'New customer'
    },
    subtitle(): string {
      if (!this.editing) return 'Choose the one to work on'
      return this.key ? 'Its name, its agent and its IT Glue record' : 'Not saved yet'
    },
  },
  watch: {
    show(value: boolean) {
      if (value) this.list()
    },
  },
  methods: {
    save(): void {
      ;(this.$refs.form as FormHandle | undefined)?.save()
    },
    edit(key?: string): void {
      this.key = key
      this.editing = true
    },
    list(): void {
      this.editing = false
      this.key = undefined
      this.reload += 1
    },
    saved(): void {
      this.list()
      this.$emit('changed')
    },
  },
})
</script>
